interface SearchTree<T> {
  key?: string;
  value?: string|number;
  childkey?: string;
  treeList: T[]
}
interface TObject {
  [key:string]: any
}
/**
 * 查找父节点
 * @param param0
 * @returns
 */
export function searchParentNodeForTree <T extends TObject> ({ key = 'id', value, childkey = 'children', treeList }: SearchTree<T>):T|undefined {
  function deep (list: T[], parentNode?: T|undefined): T|undefined {
    for (let i = 0; i < list.length; i++) {
      const node = list[i]
      if (node[key] === value) {
        return parentNode
      } else {
        if (node[childkey]?.length) return deep(node[childkey], node)
      }
    }
  }
  return deep(treeList)
}
/**
 * 查找子节点
 * @param param0
 * @returns
 */
export function searchChildrenForTree <T extends TObject> ({ key = 'id', value, childkey = 'children', treeList }: SearchTree<T>): T[]|undefined {
  function deep (list: T[]): T[]|undefined {
    for (let i = 0; i < list.length; i++) {
      const node = list[i]
      if (node[key] === value) {
        return node[childkey]
      } else {
        if (node[childkey]?.length) return deep(node[childkey])
      }
    }
  }
  return deep(treeList)
}
